import { createHistory } from 'history';

if (!window.graylogHistory) {
  window.graylogHistory = createHistory();
}

export default window.graylogHistory;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/util/History.js